import React from 'react';
import assertions from 'lib/assertions';
import Row from 'components/Row';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import Select from 'components/Select';

export type TutoringSelfServeViewStudentDetailsUnauthenticatedState = {
  selectedChildName: string;
  selectedSubject: string;
  selectedGradeLevel: string;
};

export type Props = Partial<TutoringSelfServeViewStudentDetailsUnauthenticatedState> & {
  subjects: string[];
  gradeLevels: string[];
  onGradeLevelChange: (gradeLevel: string) => void;
  onChildNameChange: (childName: string) => void;
  onSubjectChange: (subject: string) => void;
  showChildNameFormElement?: boolean;
};

export const renderChildNameFormElement = (
  selectedChildName: string,
  setChildSelectedName: (childSelectedName: string) => void
) => {
  return (
    <Row size="large">
      <FormElement
        data-test="student-details-name-field"
        onValidChange={e => setChildSelectedName(e.target.value)}
        onInvalidChange={() => setChildSelectedName('')}
        validate={e => assertions.firstAndLastName(e.target.value)}
        label="Your student’s name"
        element={Input}
        elementProps={{
          name: 'student-name-field',
          defaultValue: selectedChildName,
          placeholder: 'First and last name',
        }}
        trimWhitespace
      />
    </Row>
  );
};

export default function TutoringSelfServeViewStudentDetails(props: Props) {
  const {
    onGradeLevelChange,
    onChildNameChange,
    onSubjectChange,
    selectedChildName = '',
    selectedGradeLevel,
    selectedSubject,
    subjects,
    gradeLevels,
    showChildNameFormElement = false,
  } = props;

  const subjectOptions = subjects?.map(s => ({ label: s, value: s }));
  const gradeLevelOptions = gradeLevels?.map(s => ({ label: s, value: s }));

  return (
    <React.Fragment>
      {showChildNameFormElement && renderChildNameFormElement(selectedChildName, onChildNameChange)}
      <Row size="large">
        <FormElement
          data-test="student-details-gradeLevel-dropdown"
          onValidChange={e => {
            onGradeLevelChange(e);
          }}
          label="Grade level"
          element={Select}
          elementProps={{
            options: gradeLevelOptions,
            placeholder: 'Select grade level',
            value: selectedGradeLevel,
          }}
        />
      </Row>
      <Row size="large">
        <FormElement
          data-test="student-details-subject-dropdown"
          onValidChange={e => {
            onSubjectChange(e);
          }}
          label="Subject to cover"
          element={Select}
          elementProps={{
            options: subjectOptions,
            placeholder: 'Select subject',
            value: selectedSubject,
          }}
        />
      </Row>
    </React.Fragment>
  );
}
